// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "110") return "static/css/110.73f7413c.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}